<template>
  <a-card title="Movimiento" bodyStyle="padding: 0px;" :bordered="false">
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="Fecha de movimiento">
        {{ formatDateOnly(movement.movementDate) }}
      </a-descriptions-item>
      <a-descriptions-item label="Fecha de importación">
        {{ formatDateTime(movement.createdAt) }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script setup>
import { defineProps } from 'vue';

const formatDateOnly = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('es-CL', { timeZone: 'UTC' });
};

const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('es-CL', { timeZone: 'America/Santiago' });
};

defineProps({
  movement: {
    type: Object,
    required: true
  }
});
</script>
